import { CtaButtonClientSide } from '@components/app/WhitePaper/CtaButton.client'
import { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import Link from '@components/primitives/Link'
import { classMerge } from '@components/utilities/classMerge'
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload'
import { Suspense } from 'react'

export interface CtaButtonProps {
  className?: string
  label: string
  url: string
}

export function CtaButton(props: CtaButtonProps) {
  return (
    <Suspense fallback={<CtaButtonServerSide {...props} />}>
      <CtaButtonClientSide {...props} />
    </Suspense>
  )
}

export function CtaButtonServerSide({ className, label, url }: CtaButtonProps) {
  return (
    <Link
      className={classMerge(
        buttonClassNames.legacy.fill.black,
        'my-5 w-80 rounded-full px-3 py-2',
        className,
      )}
      href={url}
    >
      <span className='text-white'>
        <Icon className='mr-3 text-white' icon={faDownload} />
        {label}
      </span>
    </Link>
  )
}
